import { Select } from "antd";

const OnboardingMultiSelect = ({ className = "", style, ...props }) => (
  <Select
    mode="multiple"
    maxTagCount="responsive"
    className={`onboarding-multi-select w-full ${className}`.trim()}
    style={{ width: "100%", ...style }}
    {...props}
  />
);

export default OnboardingMultiSelect;
